module.exports = "<p>example1 works!</p>\r\n"